/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap'
import Vue from 'vue'
window.Vue = Vue.default

/**
 * Ajax通信 (axios)
 * https://www.npmjs.com/package/axios
 * ※ bootstrap.jsで読み込まれているのでコメントアウトします
 *   ↓↓↓
 */
// window.axios = require('axios');

/**
 * スライダー (swiper)
 * https://www.npmjs.com/package/swiper
 */
import VueAwesomeSwiper from 'vue-awesome-swiper'
window.VueAwesomeSwiper = VueAwesomeSwiper
Vue.use(window.VueAwesomeSwiper, {
  lazy: true,
});

/**
 * スクロール
 * https://www.npmjs.com/package/vue-scrollto
 */
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease"
});

/**
 * カウント
 */
import countTo from 'vue-count-to'
Vue.component('count-to', countTo)

/**
 * 画像の遅延読み込み
 * https://github.com/alexjoverm/v-lazy-image
 */
import VLazyImage from "v-lazy-image"
Vue.use(VLazyImage)

/**
 * Font Awesome (Webアイコンフォント)
 * https://fontawesome.com/icons?d=gallery
 *
 * ■ vue-fontawesome
 * https://github.com/FortAwesome/vue-fontawesome
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons/faChevronCircleLeft'
import { faChevronCircleRight } from '@fortawesome/free-solid-svg-icons/faChevronCircleRight'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faChevronCircleLeft, faChevronCircleRight, faMapMarkerAlt)
Vue.component('font-awesome-icon', FontAwesomeIcon)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 */

Vue.component('area-resion-list-component', () => import('./components/AreaResionListComponent.vue'))
Vue.component('job-search-form-component', () => import('./components/JobSearchFormComponent.vue'))
Vue.component('job-search-form-for-top-component', () => import('./components/JobSearchFormForTopComponent.vue'))
Vue.component('to-top-page-component', () => import('./components/ToPageTopComponent.vue'))
Vue.component('latest-jobs-component', () => import('./components/LatestJobsComponent.vue'))
Vue.component('voice-swiper-component', () => import('./components/VoiceSwiperComponent.vue'))
Vue.component('recently-job-list-component', () => import('./components/RecentlyJobListComponent.vue'))
Vue.component('job-recommended-list-for-area-component', () => import('./components/JobRecommendedListForAreaComponent.vue'))
Vue.component('consideration-button', () => import('./components/ConsiderationButtonComponent.vue'))
Vue.component('top-consideration-tab', () => import('./components/TopConsiderationTabComponent.vue'))
Vue.component('top-consideration-tab-old', () => import('./components/TopConsiderationTabComponentOld.vue'))
Vue.component('magazine-recent-posts-component', () => import('./components/MagazineRecentPostsComponent.vue'))
Vue.component('previous-companies-component', () => import('./components/PreviousCompaniesComponent.vue'))
Vue.component('station-select-component', () => import('./components/StationSelectComponent.vue'))
Vue.component('lp-accounting-firm-header-component', () => import('./components/LpAccountingFirmHeaderComponent.vue'))
Vue.component('casset-component', () => import('./components/CassetComponent.vue'))
Vue.component('private-casset-component', () => import('./components/PrivateCassetComponent.vue'))
Vue.component('star-rating-component', () => import('./components/StarRatingComponent.vue'))
Vue.component('ranking-casset-component', () => import('./components/RankingCassetComponent.vue'))
Vue.component('entry-chat-component', () => import('./components/EntryChatComponent.vue'))
Vue.component('featured-latest-job-component', () => import('./components/FeaturedLatestJobComponent.vue'))
Vue.component('glossary-suggester-component', () => import('./components/GlossarySuggesterComponent.vue'))
Vue.component('latest-occupation-jobs-component', () => import('./components/LatestOccupationJobsComponent.vue'))
Vue.component('wrap-entry-chat-component', () => import('./components/WrapEntryChatComponent.vue'))

/**
 * ストア
 */
import store from './store'
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: '#app',
  store,
  components: {
    VLazyImage
  }
});
